module.exports = __webpack_public_path__ + "ec2c8cdcd4d35af6edf28e78d73be1a1.png";